<template>
    <section class="c-header-nav-links">
        <ul class="c-header-nav-links__inner">
            <app-header-nav-links-item v-for="(navLink, index) in navigation" :key="index" :nav-link="navLink" />
        </ul>
    </section>
</template>

<script>
import { routes } from "src/router";
import AppHeaderNavLinksItem from "components/AppHeader/AppHeaderNav/AppHeaderNavLinks/AppHeaderNavLinksItem";
export default {
    components: {
        AppHeaderNavLinksItem,
    },
    computed: {
        navigation() {
            const navRouteNames = ["campaign_2022", "economies", "campaign_2021", "places", "facts"];
            let nav = routes.filter((route) => navRouteNames.includes(route.name));

            nav = nav.map((route) => ({
                path: route.path,
                title: this.$store.getters["global/getSingleTitle"](route.meta.prismicHandle),
                isExternal: false,
            }));

            nav.push({
                path: "https://www.google.com/maps/d/u/0/edit?mid=1-pZxu4g1g9Z_DYoXK8y-STHWq7Q-zn1Z&usp=sharing",
                title: this.$t("shared.direction"),
                isExternal: true,
            });

            return nav;
        },
    },
};
</script>

<style lang="scss">
.c-header-nav-links {
    display: flex;
    &__inner {
        @include reset-list;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
    }
}
</style>
